import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import contactImg from "../../../assets/images/hellopic.png";

const Contact = () => {
  const handleFormSubmit = (e) => {
    // e.preventdefault();
    alert("Thanks for send message.");
  };
  return (
    <div id="contact">
      <h2 className="text-center">Contact me</h2>
      <Container>
        <Row xs={1} md={2}>
          <Col>
            <form className="contact-form" onSubmit={handleFormSubmit}>
              <p>Name</p>
              <input type="text" placeholder="Name" />
              <p>Email</p>
              <input type="text" placeholder="Email" />
              <p>Leave a message</p>
              <textarea placeholder="Message" />
              <input type="submit" className="primary-btn" value="Submit" />
            </form>
          </Col>
          <Col>
            <img width="100%" src={contactImg} alt="" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
